module.exports = __webpack_public_path__ + "static/cookie-4f931edd34437b35c3f1faf9ddcf4ede.png";